import type { PropsWithChildren } from 'react';
import { useSettings } from '@wu/widget-core';

export const FilterPage = ({ children }: PropsWithChildren) => {
  const { whereToDisplayChat, excludedPages, specificPages, editMode } =
    useSettings();

  const pagesData = {
    specificPages,
    excludedPages,
    allPages: []
  };

  /**
   * remove from url: protocol, www., / - from the end
   */
  const clearUrl = (url: string) =>
    url.replace(/((http|https):\/\/)|(www\.)|(\/)$/g, '').replace(/\/$/, '');

  const escapeRegexpWithAsterisk = (string: string) =>
    string.replace(/[/.*+?^${}()|[\]\\]/g, (match) => {
      if (match === '*') return '(.+)';

      return `\\${match}`;
    }) + '$';

  const getPredefinedPattern = (name: string) => {
    const host = clearUrl(document.location.host);
    const predefinedPatterns = {
      homepage: '(\\/)?(index\\.(.*))?($|\\?)'
    };

    if (name in predefinedPatterns)
      return `${host}${
        predefinedPatterns[name as keyof typeof predefinedPatterns]
      }`;

    return escapeRegexpWithAsterisk(name);
  };

  const checkMatch = (url: string, pattern: string) => {
    if (!url || !pattern) {
      return false;
    }
    const regExpPattern = getPredefinedPattern(pattern);
    const regExp = new RegExp(regExpPattern);

    return regExp.test(url);
  };

  const pagesList = pagesData[whereToDisplayChat];

  const locationUrl = clearUrl(window.location.href);
  const showChat = pagesList.find((page) =>
    checkMatch(locationUrl, clearUrl(page.url))
  )
    ? whereToDisplayChat !== 'excludedPages'
    : whereToDisplayChat === 'excludedPages';

  if (showChat || editMode || !pagesList.length) {
    return children;
  }

  return null;
};
